import React, { useEffect, useState } from "react";
import HomeFragment from "../fragment/HomeFragment";
import RedeemFragment from "../fragment/RedeemFragment";
import TransactionFragment from "../fragment/TransactionFragment";
import LogoDompetKartini from "../assets/images/logo-dompet-kartini.png";
import { Link, Navigate } from "react-router-dom";
import InboxFragment from "../fragment/InboxFragment";
import EwalletFragment from "../fragment/EwalletFragment";
import axios from "axios";
import { HEADER } from "../utils/Utils";
import _ from "lodash";
import GenerateFragment from "../fragment/GenerateFragment";

export default function Home() {
  const [menu, setMenu] = useState("home");
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("dompet_user")),
  );
  const [dataOutlet, setDataOutlet] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );

  useEffect(() => {
    if (
      localStorage.getItem("dompet_user") ||
      localStorage.getItem("dompet_detail_outlet")
    ) {
      GetDataUser();
      GetOutletKartini();
      GetChannelData();
    }
    return () => {
      setDataOutlet(null);
    };
  }, []);

  async function GetDataUser(params) {
    try {
      let res_user = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${user.akuisisi_id}`,
        { headers: HEADER },
      );
      res_user = res_user.data.data;
      // update local storage user
      localStorage.setItem(
        "dompet_user",
        JSON.stringify({ ...user, ...res_user }),
      );
      setUser((prevState) => ({
        ...prevState,
        ...res_user,
      }));
    } catch (error) {
      console.error(error);
    }
  }

  async function GetChannelData() {
    try {
      // get admin details
      let res_admin = await await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/akuisisi?channel_id=${dataOutlet.channel_id}&user_type=admin`,
        { headers: HEADER },
      );
      // get data outlets
      let res_channel = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/channel/${dataOutlet.channel_id}`,
        { headers: HEADER },
      );
      res_channel = res_channel.data.data;
      localStorage.setItem(
        "dompet_detail_outlet",
        JSON.stringify({
          ...dataOutlet,
          ...res_channel,
          admin: res_admin.data.data[0].user_name,
        }),
      );
      setDataOutlet((prevState) => ({
        ...prevState,
        ...res_channel,
        admin: res_admin.data.data[0].user_name,
      }));
    } catch (error) {
      console.error(error);
    }
  }

  async function GetOutletKartini() {
    try {
      let res_outlet = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini/${user.outlet_kartini_id}`,
        { headers: HEADER },
      );
      res_outlet = res_outlet.data.data;
      setDataOutlet((prevState) => ({
        ...prevState,
        ...res_outlet,
      }));
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      {/* {window.innerWidth > 768 && <Navigate to="/require" />} */}
      {_.isEmpty(user) || _.isEmpty(dataOutlet) ? (
        <Navigate to="/signin" />
      ) : (
        <div className="no-scrollbar relative overflow-y-scroll bg-white">
          <div className="fixed top-0 z-50 w-full bg-white px-5 pt-6 shadow-sm">
            <div className="mx-auto flex max-w-screen-xl flex-col space-y-4">
              <div className="flex items-center justify-between ">
                <div className="block">
                  <img
                    className="w-14"
                    src={LogoDompetKartini}
                    alt="logo-kartini-color"
                  />
                </div>
                <Link to="/profile">
                  {!_.isEmpty(dataOutlet.channel_logo) ? (
                    <img
                      className="rounded-full shadow"
                      src={dataOutlet.channel_logo}
                      width="42"
                      height="42"
                      alt="Avatar"
                    />
                  ) : (
                    <div className="flex items-center justify-center rounded-full bg-[#4CA6F8] px-2 py-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                  )}
                </Link>
              </div>
              <>
                <div className="text-xl text-[#7D7C7C]">
                  Welcome,{" "}
                  <span className="font-semibold text-[#4CA6F8]">
                    {user.user_name ?? ""}
                  </span>
                  <br />
                  <span className="text-sm">to Dompet Kartini</span>
                </div>
              </>
              <>
                <ul className="no-scrollbar flex justify-start space-x-5 overflow-x-scroll pb-2 text-sm font-medium sm:justify-around">
                  <li>
                    <button
                      className={`${
                        menu === "home"
                          ? "text-[#4CA6F8]"
                          : "text-gray-500 hover:text-gray-600"
                      } flex items-center whitespace-nowrap`}
                      onClick={() => setMenu("home")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-2 h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                        />
                      </svg>
                      <span
                        className={`${
                          menu === "home" ? "font-bold" : "font-medium"
                        }`}
                      >
                        Home
                      </span>
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${
                        menu === "redeem"
                          ? "text-[#4CA6F8]"
                          : "text-gray-500 hover:text-gray-600"
                      } flex items-center whitespace-nowrap`}
                      onClick={() => setMenu("redeem")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-2 h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                        />
                      </svg>
                      <span
                        className={`${
                          menu === "redeem" ? "font-bold" : "font-medium"
                        }`}
                      >
                        Redeem
                      </span>
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${
                        menu === "transaction"
                          ? "text-[#4CA6F8]"
                          : "text-gray-500 hover:text-gray-600"
                      } flex items-center whitespace-nowrap`}
                      onClick={() => setMenu("transaction")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-2 h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                        />
                      </svg>
                      <span
                        className={`${
                          menu === "transaction" ? "font-bold" : "font-medium"
                        }`}
                      >
                        Transaction
                      </span>
                    </button>
                  </li>
                  {(dataOutlet.channel_id === "609" ||
                    dataOutlet.channel_id === "2589" ||
                    dataOutlet.channel_id === "2590" ||
                    dataOutlet.channel_id === "3152") && (
                    <li>
                      <button
                        className={`${
                          menu === "generate"
                            ? "text-[#4CA6F8]"
                            : "text-gray-500 hover:text-gray-600"
                        } flex items-center whitespace-nowrap`}
                        onClick={() => setMenu("generate")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="mr-2 h-5 w-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
                          />
                        </svg>
                        <span
                          className={`${
                            menu === "generate" ? "font-bold" : "font-medium"
                          }`}
                        >
                          QR Referal
                        </span>
                      </button>
                    </li>
                  )}
                  <li>
                    <button
                      className={`${
                        menu === "e-wallet"
                          ? "text-[#4CA6F8]"
                          : "text-gray-500 hover:text-gray-600"
                      } flex items-center whitespace-nowrap`}
                      onClick={() => setMenu("e-wallet")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="mr-2 h-5 w-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"
                        />
                      </svg>
                      <span
                        className={`${
                          menu === "e-wallet" ? "font-bold" : "font-medium"
                        }`}
                      >
                        E-wallet
                      </span>
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${
                        menu === "inbox"
                          ? "text-[#4CA6F8]"
                          : "text-gray-500 hover:text-gray-600"
                      } flex items-center whitespace-nowrap`}
                      onClick={() => setMenu("inbox")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="mr-2 h-5 w-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"
                        />
                      </svg>
                      <span
                        className={`${
                          menu === "inbox" ? "font-bold" : "font-medium"
                        }`}
                      >
                        Inbox
                      </span>
                      <span class="relative -mt-2 flex h-2 w-2">
                        <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
                        <span class="relative inline-flex h-2 w-2 rounded-full bg-red-500"></span>
                      </span>
                    </button>
                  </li>
                </ul>
              </>
            </div>
          </div>
          <div className="mx-auto max-w-screen-xl px-4 pt-[212px] xl:px-0 ">
            {menu === "home" ? (
              <HomeFragment />
            ) : menu === "redeem" ? (
              <RedeemFragment />
            ) : menu === "transaction" ? (
              <TransactionFragment />
            ) : menu === "e-wallet" &&
              user.user_type !== "member" &&
              dataOutlet.ewallet_status === "active" ? (
              <EwalletFragment />
            ) : menu === "generate" && user.user_type === "admin" ? (
              <GenerateFragment />
            ) : (
              menu === "inbox" && <InboxFragment />
            )}
          </div>
        </div>
      )}
    </>
  );
}
